/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Delete_TitleInputs */



/**
* | output |
* | --- |
* | "Delete this template?" |
*
* @param {Settings_Template_Delete_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_delete_title = /** @type {((inputs?: Settings_Template_Delete_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Delete_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Deze template verwijderen?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer ce modèle ?")
	return /** @type {LocalizedString} */ ("Delete this template?")
});